import React from 'react'

import DocumentMoreMenu from "./more-menu"
import Document from "../../../model2/doc/document"
import ControlButtonStandard, {
    ControlButtonType
} from "../../../gd-components/buttons/control-button/control-button-standard";
import {ControlButtonSize} from "../../../gd-components/buttons/control-button/@types";
import Classes from "classnames";
import Popover from "../../../gd-components/gd-popover/popover";
import {PopoverAttachmentType} from "../../../gd-components/gd-popover/@const";
import {findDOMNode} from "react-dom";

export type DocumentMoreConfig = {
    rename?             : boolean | 'disabled',
    openNewWindow?      : boolean | 'disabled',
    pin?                : boolean | 'disabled',
    export?             : boolean | 'disabled',
    move?               : boolean | 'disabled',
    convert?            : boolean | 'disabled',
    delete?             : boolean | 'disabled',
    duplicate?          : boolean | 'disabled',
    saveAsTemplate?     : boolean | 'disabled',
}

type TitleFieldPropTypes = {
    className?          : string,
    type?               : 'default'|'menu'
    model               : Document,  // ?? what is that ?
    revisionId?         : string,
    config?             : DocumentMoreConfig,

    onTogglePopover?    : onChangeCallback
}

type State = {
    showPopover     : boolean
}

export default class DocumentMoreButton extends React.Component<TitleFieldPropTypes, State> {

    // static defaultProps: any = defaultProps
    public config : DocumentMoreConfig      = {}

    constructor(props: TitleFieldPropTypes) {
        super(props)

        this.config     = {
            rename          : _.get(props.config,'rename', true),
            openNewWindow   : _.get(props.config,'openNewWindow', true),
            pin             : _.get(props.config,'pin', true),
            export          : _.get(props.config,'export', false),
            move            : _.get(props.config,'move', true),
            convert         : _.get(props.config,'convert', true),
            delete          : _.get(props.config,'delete', true),
            duplicate       : _.get(props.config,'duplicate', true),
            saveAsTemplate  : _.get(props.config,'saveAsTemplate', true),
        }

        // patch
        if (this.props.model.isPage) {
            this.config.duplicate       = 'disabled'
            this.config.saveAsTemplate  = 'disabled'
        }

        this.state = {
            showPopover: false
        }
    }

    onShowPopover = (e: React.SyntheticEvent): void => {

        e.stopPropagation()

        this.setState({
            showPopover: true
        })
    }

    onClickOutside = ()=> {
        this.setState({showPopover: false})
    }

    render() {

        const moreButton = Classes("more", {
            'popover-shown'         : this.state.showPopover
        })

        return (
            <ControlButtonStandard className    = {moreButton}
                                   type         = {ControlButtonType.MORE}
                                   size         = {ControlButtonSize.SIZE_24}
                                   onClick      = {this.onShowPopover}>
                {this.state.showPopover && (
                    <Popover attachment         = "top left"
                             targetAttachment   = "top right"
                             offset             = "10 0"
                             attachmentType     = {PopoverAttachmentType.VERTICAL}
                             getTargetFunc      = {()=>findDOMNode(this)}
                             onClickOutside     = {this.onClickOutside}>

                        <DocumentMoreMenu model         = {this.props.model}
                                          config        = {this.config}
                                          revisionId    = {this.props.revisionId}
                                          hidePopover   = {this.onClickOutside}/>

                    </Popover>
                )}
            </ControlButtonStandard>
        );
    }
}
